import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Icon, Row, Col } from 'antd';
import { showCompareVersions, showComment } from '../../actions/CommentAction';
import { KEY_CODE_ESC } from '../../utils'
import VideoView from '../assets-view/VideoView'
import DocumentView from '../document-view/DocumentView'
import Viewer from 'react-viewer';
import { AUDIO_EXT } from '../../utils/index'
import fileextension from 'file-extension'
import AudioView from '../assets-view/AudioView'
// import Zoom from 'react-img-zoom'

export class CompareVersions extends Component {
  /**
   * 
   * @param {*} props 
   */
  constructor(props) {
    super(props);
    this.state = {
      theme: 1,
      itemsVersionsToCompare: [],
      gridSpace: 24,
      gridHeight: '34em',
      showImageViewer: false,
      imageToView: null,
      imageName: null
    };
  }
  /**
   * 
   */
  componentDidMount() {
    const { versionsToCompare, allVersions } = this.props;
    this.handleGetVerisionsToCompare(versionsToCompare, allVersions);
    this.handleEvaluateGrid(versionsToCompare.length);
    document.addEventListener('keydown', this.handleKeyPressCompare, { once: false })
  }
  /**
   * @name handleGetVerisionsToCompare
   */
  handleGetVerisionsToCompare = (versionsToCompare, allVersions) => {
    this.setState({
      itemsVersionsToCompare: allVersions.filter(f => (versionsToCompare.includes(f._id) || versionsToCompare.includes(f.documentId)))
    });
  }
  /**
   * @name handleEvaluateGrid
   */
  handleEvaluateGrid = (qty) => {
    const { width } = this.props
    let values = {
      gridSpace: 24,
      gridHeight: '34em',
    };

    switch (qty) {
      case (4):
        values = {
          gridSpace: width <= 425 ? 12 : 10,
          gridHeight: width <= 425 ? '47em' : '30em',
        };
        break;
      case (3):
        values = {
          gridSpace: width <= 425 ? 12 : 8,
          gridHeight: width <= 425 ? '47em' : '64em',
        };
        break;
      case (2):
        values = {
          gridSpace: 12,
          gridHeight: width <= 425 ? '47em' : '64em',
        };
        break;
      default:
        return values;
    }
    this.setState(values);
  }
  /**
   * 
   */

  handleKeyPressCompare = e => {
    if (e.keyCode === KEY_CODE_ESC) {
      this.props.showCompareVersions(false)
    }
  }

  handleShowImageViewer = (image) => {
    const { showImageViewer } = this.state
    this.setState({
      showImageViewer: !showImageViewer,
      imageToView: image ? image.originalURL : null,
      imageName: image ? image.name : null
    })
  }

  render() {
    const { theme, itemsVersionsToCompare, gridSpace, gridHeight, showImageViewer, imageToView, imageName } = this.state;
    const { intl } = this.props;
    return (
      <div className={`dart-main dart-color-${theme}-a dart-compare`}>
        <div className='dart-close-compareVersions' style={{ zIndex: '3' }}>
          <Icon
            type="close-circle"
            onClick={() => this.props.showCompareVersions(false)}
            style={{ fontSize: 20 }} />
        </div>
        {/*  */}
        <React.Fragment>
          {
            <Row className="dart-versions-preview-row" >
              <ul className="dart-versions-ul">
                {
                  (itemsVersionsToCompare) && (itemsVersionsToCompare.length > 0) && itemsVersionsToCompare.map((version, k) => {
                    return <React.Fragment key={version._id} >
                      <Col span={gridSpace}  >
                        <div className="dart-version-item" style={{ margin: '7px' }}>
                          <p style={{ marginBottom: '6px' }}>
                            <span className="dart-span-name-versions">
                              {intl.formatMessage({ id: "version" })} &nbsp;&nbsp;{version.versionNumber}
                            </span>
                          </p>

                          <li className="dart-version-transparent" style={{ height: gridHeight, listStyle: 'none' }}>
                            {version.document.type === 'image'
                              &&
                              // <div className='dart-versions-asset-preview' onClick={() => this.handleShowImageViewer(version.document)} >
                              // <Zoom
                              //   img={version.document.originalURL}
                              //   zoomScale={3}
                              //   width={600}
                              //   height={400}
                              //   onClick={() => this.handleShowImageViewer(version.document)}
                              // />
                              // </div>
                              <img onMouseEnter={() => document.body.style.cursor = "zoom-in"}
                                onMouseLeave={() => document.body.style.cursor = "default"}
                                src={version.document.originalURL}
                                alt={k}
                                onClick={() => this.handleShowImageViewer(version.document)}
                                className="dart-versions-asset-preview"
                              //className='zoom'
                              />
                            }
                            {/*VIDEO*/}
                            {
                              version.document.type === 'video' && <VideoView
                                url={version.document.mediaQualityURL}
                                disableDefaultControls={false}
                                autoPlay={true}
                              />
                            }
                            {/*DOCUMENT*/}

                            {version.document.type === 'document' && AUDIO_EXT.includes(fileextension(version.document.originalURL)) && <AudioView item={version.document} autoplay={false} />}
                            {version.document.type === 'document' && !AUDIO_EXT.includes(fileextension(version.document.originalURL)) && <DocumentView item={version.document} />}
                          </li>
                        </div>
                      </Col>
                    </React.Fragment>
                  })
                }
              </ul>
            </Row>
          }
          <Viewer
            visible={showImageViewer}
            zoomable={true}
            onClose={() => this.handleShowImageViewer(null)}
            // showTotal={false}
            changeable={false}
            images={[{ src: imageToView, alt: imageName }]}
          />
        </React.Fragment>
      </div >
    )
  }
}

const mapStateToProps = state => {
  return {
    showCommentList: state.comments.showCommentList,
    itemSelected: state.comments.itemSelected,
    itemSelectedFetching: state.comments.itemSelectedFetching,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    width: state.app.width,
    versionsToCompare: state.comments.versionsToCompare,
    allVersions: state.comments.allVersions,
  }
}

const mapDispatchToProps = {
  showCompareVersions,
  showComment
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(CompareVersions)))